import { compose } from 'recompose';
import { connect } from 'react-redux';
import CSSModules from 'react-css-modules';

import {
  selectPatientProfileAlreadyExists,
  selectSavedPatientPersonalInfo,
  selectSavedPatientContacts,
  selectSavedPatientAddress,
  addPatientSuccessSelector,
  selectAddedPatientsList,
} from '../../../redux/profiles/selectors';
import styles from '../PatientRegistrationInfo/index.styl';
import { actions as createPatient } from '../../../redux/profiles/addPatientByProvider';

const mapDispatchToProps = {
  createPatient: createPatient.send,
  clearRequest: createPatient.clear,
};

const mapStateToProps = state => ({
  personalInfo: selectSavedPatientPersonalInfo(state),
  patientContacts: selectSavedPatientContacts(state),
  patientAddress: selectSavedPatientAddress(state),
  isAddPatientSuccess: addPatientSuccessSelector(state),
  patientProfileAlreadyExists: selectPatientProfileAlreadyExists(state),
  emergencyContactPatientList: selectAddedPatientsList(state),
});

export const enhance = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  CSSModules(styles, { allowMultiple: true }),
);



// WEBPACK FOOTER //
// ./src/components/PatientRegistration/PatientEmergencyContact/enhance.js